// noinspection DuplicatedCode

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// noinspection ES6PreferShortImport
import { PageNotFoundComponent } from '../standalone/page-not-found/page-not-found.component';
import { DashboardComponent } from './dashboard/dashboard.component';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
  },
  {
    path: 'users',
    loadChildren: () =>
      import('../../shared/users/users.module').then(m => m.UsersModule),
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NoRoleRoutingModule {}
